module.exports = __webpack_public_path__ + "static/media/tn-mpants-ankle-long.73703288.svg";